import { Record, Map } from 'immutable';
import { actionTypes } from './touchpoint-list.actions';
import { authActions } from '../../../auth';
import { siteListActions } from '../site-list-folder';
import { Err } from '../../../err';
import { ApiCallState } from '../../../api';

export const FormListState = Record({
  err: null,
  isFetching: false,
  isValid: false,
  formList: null
});

export const FormsState = Record({
  currentPage: 1,
  itemsPerPage: 25,
  sortBy: 'name',
  sortAsc: true,
  formListState: FormListState({}),
  formsEditData: Map({})
});

export const SiteForms = Record({
  formLists: Map({}),
  /** contains loading state for individual forms */
  allForms: Map({}),
});

export const touchpointListReducer = (state = new SiteForms(), action) => {
  switch (action.type) {
    case authActions.actionTypes.CREATE_ETO_SESSION_SUCCESS:
      return state.set('formLists', new Map({}));
    case siteListActions.actionTypes.CHANGE_SELECTED_SITE:
      if(action.siteId !== null) {
        const formsState = state.getIn(['formLists', action.siteId]);
        if(!formsState) {
          return state.setIn(['formLists', action.siteId], new FormsState({}));
        }
      }
      return state;
    case actionTypes.FETCH_FORM_DETAILS_BEGIN:
      return state.withMutations((initialState) => {
        action.formIds.forEach(id => {
          initialState.setIn(['allForms', id], new ApiCallState({
            isFetching: true
          }));
        });
      });
    case actionTypes.FETCH_FORM_DETAILS_SUCCESS:
      return state.withMutations((initialState) => {
        action.formIds.forEach(id => {
          const form = action.data.results.find(val => val.id === id);
          initialState.setIn(['allForms', id], new ApiCallState({
            data: form,
            isValid: true
          }));
        });
      });
    case actionTypes.FETCH_FORM_DETAILS_FAILURE:
      return state.withMutations((initialState) => {
        action.formIds.forEach(id => {
          initialState.setIn(['allForms', id], new ApiCallState({
            err: new Err(action.err),
            isValid: true
          }));
        });
      });
    case actionTypes.FETCH_FORM_LIST_BEGIN:
      return state.setIn(['formLists', action.siteId, 'formListState'], new FormListState({
        isFetching: true
      }));
    case actionTypes.FETCH_FORM_LIST_SUCCESS:
      return state.setIn(['formLists', action.siteId, 'formListState'], new FormListState({
        formList: action.data,
        isValid: true
      }));
    case actionTypes.FETCH_FORM_LIST_FAILURE:
      return state.setIn(['formLists', action.siteId, 'formListState'], new FormListState({
        err: new Err(action.err),
        isValid: true
      }));
    case actionTypes.CHANGE_PAGE_NUMBER:
      return state.setIn(['formLists', action.siteId, 'currentPage'], action.page)
        .setIn(['formLists', action.siteId, 'formListState', 'isValid'], false);
    case actionTypes.CHANGE_SORT:
      return state.setIn(['formLists', action.siteId, 'sortBy'], action.sortBy)
        .setIn(['formLists', action.siteId, 'sortAsc'], action.sortAsc)
        .setIn(['formLists', action.siteId, 'formListState', 'isValid'], false);
    case actionTypes.SHOW_FORM_DETAILS:
      return state.setIn(['formLists', action.siteId, 'formsEditData', action.id, 'show'], action.show);
    default:
      return state
  }
}
